import { Paper, Stack, Theme } from '@mui/material';
import Typography from '@mui/material/Typography';
import { shallowEqual } from 'react-redux';
import { makeStyles } from 'tss-react/mui';
import { MinimalPageLayout } from '../components/Navigation/MinimalLayout/MinimalPageLayout';
import { ButtonLogout } from '../components/Shared/ButtonLogout';
import { StayInContactIcon } from '../components/Shared/StayInContactIcon';
import { ButtonStopImpersonating } from '../components/Support/ButtonStopImpersonating';
import { useAppSelector } from '../store/hooks';

export function NoSicPage() {
    const { classes } = useStyles();

    const user = useAppSelector(state => {
        return state.user;
    }, shallowEqual);

    return (
        <MinimalPageLayout>
            <StayInContactIcon className={classes.icon} />
            <Paper className={classes.root}>
                <Stack spacing={3} justifyContent="center" alignItems="center">
                    <Typography variant="h2" className={classes.title}>
                        Welcome to StayInContact, {user.userFirstName}
                    </Typography>
                    <Typography variant="body1" className={classes.status}>
                        You do not have any StayInContact packages active.
                    </Typography>
                    <Typography variant="body1" className={classes.status}>
                        Please contact support to get started.
                    </Typography>
                    <ButtonLogout />

                    <ButtonStopImpersonating />
                </Stack>
            </Paper>
        </MinimalPageLayout>
    );
}

const useStyles = makeStyles()((theme: Theme) => ({
    root: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        flexDirection: 'column',
        padding: '2rem',

        [theme.breakpoints.up('xs')]: {
            maxWidth: '30rem',
        },
        [theme.breakpoints.up('md')]: {
            maxWidth: '50rem',
        },
    },
    icon: {
        maxWidth: '250px',
    },
    status: {
        textAlign: 'center',
    },
    title: {
        textAlign: 'center',
    },
}));
